"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-35',
    connection_id: 'connection-10'
  },
  chain_2: {
    chain_name: 'composable',
    client_id: '07-tendermint-138',
    connection_id: 'connection-55'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-12',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-38',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-82',
    connection_id: 'connection-52'
  },
  chain_2: {
    chain_name: 'dymension',
    client_id: '07-tendermint-6',
    connection_id: 'connection-5'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-27',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-79',
    connection_id: 'connection-49'
  },
  chain_2: {
    chain_name: 'evmos',
    client_id: '07-tendermint-134',
    connection_id: 'connection-80'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-26',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-106',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-28',
    connection_id: 'connection-6'
  },
  chain_2: {
    chain_name: 'injective',
    client_id: '07-tendermint-226',
    connection_id: 'connection-210'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-7',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-152',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-49',
    connection_id: 'connection-12'
  },
  chain_2: {
    chain_name: 'kava',
    client_id: '07-tendermint-158',
    connection_id: 'connection-198'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-13',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-140',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-29',
    connection_id: 'connection-7'
  },
  chain_2: {
    chain_name: 'neutron',
    client_id: '07-tendermint-48',
    connection_id: 'connection-36'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-8',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-35',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-10',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3012',
    connection_id: 'connection-2503'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-6994',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-52',
    connection_id: 'connection-15'
  },
  chain_2: {
    chain_name: 'secretnetwork',
    client_id: '07-tendermint-174',
    connection_id: 'connection-131'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-14',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-91',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-0',
    connection_id: 'connection-4'
  },
  chain_2: {
    chain_name: 'stride',
    client_id: '07-tendermint-137',
    connection_id: 'connection-125'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-162',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-53',
    connection_id: 'connection-16'
  },
  chain_2: {
    chain_name: 'terra2',
    client_id: '07-tendermint-391',
    connection_id: 'connection-381'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-15',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-300',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;